import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon46: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M7.01979 6.65306L8.80678 0.894053C9.17678 -0.300947 10.8228 -0.300947 11.1928 0.894053L12.9798 6.65306H18.7457C19.9627 6.65306 20.4558 8.24305 19.4908 8.97505L14.8068 12.5411L16.5978 18.316C16.9628 19.493 15.6488 20.494 14.6618 19.742L9.99977 16.1961L5.33876 19.7431C4.34976 20.4931 3.03675 19.493 3.40175 18.316L5.19374 12.5411L0.508747 8.97505C-0.455253 8.24305 0.037765 6.65306 1.25277 6.65306H7.01979ZM10.2378 1.19105C10.1578 0.93405 9.8418 0.93405 9.7618 1.19105L7.8658 7.30107C7.8008 7.51007 7.60677 7.65306 7.38777 7.65306H1.25277C1.01277 7.65306 0.899788 8.01606 1.11379 8.18006L6.07778 11.9571C6.24478 12.0841 6.31476 12.3021 6.25277 12.5031L4.35677 18.613C4.27177 18.886 4.54278 19.0921 4.73378 18.9471L9.69777 15.1701C9.87577 15.0331 10.1238 15.0331 10.3028 15.1701L15.2668 18.9471C15.4578 19.0911 15.7278 18.886 15.6428 18.613L13.7478 12.5031C13.6858 12.3021 13.7547 12.0841 13.9227 11.9571L18.8858 8.17906C19.1008 8.01606 18.9877 7.65306 18.7457 7.65306H12.6108C12.3918 7.65306 12.1987 7.51007 12.1337 7.30107L10.2378 1.19105Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
